import getConfig from 'next/config';
import { Vertical } from '../consts/verticalContents';
import { sendPostMessage } from './browser-utils';
import { getSessionId } from './event-helper';

const { publicRuntimeConfig: { config } } = getConfig();

const getVerticalRoute = (vertical, allowNotFoundPage?) => {
  const lowerCaseVertical = vertical.toLowerCase();
  switch (lowerCaseVertical) {
    case Vertical.SPORT:
    case Vertical.SPORTS:
    case Vertical.GAMING:
      return `${Vertical.SPORT}-${Vertical.GAMING}`;
    case Vertical.TECH:
    case Vertical.COMMERCE:
    case Vertical.E_COMMERCE:
    case Vertical.TECHNOLOGY:
      return `${Vertical.TECHNOLOGY}-${Vertical.COMMERCE}`;
    case Vertical.NEWS:
    case Vertical.ENTERTAINMENT:
      return `${Vertical.NEWS}-${Vertical.ENTERTAINMENT}`;
    case Vertical.FINANCE:
      return Vertical.FINANCE;
    case Vertical.INSURANCE:
      return Vertical.INSURANCE;
    case Vertical.ALL:
      return Vertical.ALL;
    default:
      return allowNotFoundPage ? lowerCaseVertical : Vertical.ALL;
  }
};

const goToTemplateEditor = (interactionId, user, openInNewTab?, isIframe?) => {
  const { BASE_URL, EDITOR_URL } = config;
  const sessionId = getSessionId();

  const redirectUrl = user && user.userId
    ? `${EDITOR_URL}/editor/new?template=${interactionId}&sId=${sessionId}`
    : `${BASE_URL}/auth/login?sId=${sessionId}`;

  if (!isIframe) {
    if (openInNewTab) {
      window.open(redirectUrl, '_blank');
    } else {
      window.location.href = redirectUrl;
    }
  } else {
    sendPostMessage('redirect_to', { redirectUrl });
  }
};

const goToDashboard = () => {
  const { EDITOR_URL } = config;
  const sessionId = getSessionId();
  window.location.href = `${EDITOR_URL}/dashboard?sId=${sessionId}`;
};

export {
  goToTemplateEditor,
  getVerticalRoute,
  goToDashboard,
};
